<app-header *ngIf="userData.enabled=='T'" [parentUserData]="userData" [url]="url" (drawerClickEvent)="toggleDrawer($event)" (iconClicked)="getItem($event)" (refreshClicked)="refresh($event)"></app-header>
<app-login *ngIf="!loginDisplay"></app-login>

  <div *ngIf="loginDisplay && isInitializing" 
  class="loading-container">

      <div class="loading-logo-section">

        <a href="https://www.McDermott.com"> <img
                            src="../../../assets/img/mcdermott_logo.png" alt="McDermott.com Webpage"
                            style="width: 200px; height: 30px; border: 0; margin-right: 20px;"></a>

       <!-- <a routerLink="../home" >
          <img src="/assets/img/iDocsXDPortal.png" width="10%" alt="iDocs Portal Logo">
        </a>-->

      </div>

      <br>
    <div class="loader"></div>

    <h2>Welcome to iDocs XD Portal</h2>

    <p class="loading-message">
        We are setting things up for you...
    </p>

    <p class="loading-sub-message">
        Please wait while we load your account information and prepare your workspace.
    </p>

</div>

<app-non-authorized *ngIf="userData.enabled=='F'"></app-non-authorized>
<app-account-not-found *ngIf="accountNotFound"></app-account-not-found>
<div *ngIf="this.loginDisplay && userData.enabled=='T'  && !this.accountNotFound" class="main-div">
  <kendo-drawer-container>
    <kendo-drawer #drawer [items]="items" id="draw" [width]="220" mode="push" [mini]="true" [expanded]="false"
      (select)="onSelect($event)" [miniWidth]="90">
      <ng-template kendoDrawerItemTemplate let-item>
        <div class="item-descr-wrap" id="item" (click)="updateSelected(item.text)">
          <div class="item-svg-small"> <kendo-svg-icon
              [icon]="item.svgIcon" [size]="item.text === 'Submittals' ? 'xxlarge' : 'xlarge'"></kendo-svg-icon></div>   
          <div class="item-text-small"><span>{{ item.text }}</span></div>
        </div>
      </ng-template>
    </kendo-drawer>
    <kendo-drawer-content>
      <router-outlet></router-outlet>
    </kendo-drawer-content>
  </kendo-drawer-container>
</div>